import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const AeroplaneHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.6 10.958a6.65 6.65 0 0 0 1.65-4.077 3.977 3.977 0 0 0-3.64-4.013 3.64 3.64 0 0 0-3.36 2.26 3.64 3.64 0 0 0-3.365-2.26A3.976 3.976 0 0 0 7.25 6.881c.003.546.091 1.087.262 1.605m1.366 8.07L3.569 10.51l2.248-.692 8.376 4.517c3.369-1.147 4.318-1.48 5.7-1.456 2.922.05 3.775 2.425 1.124 3.655-2.488 1.154-14.914 6.43-17.794 2.038L1.5 15.94l1.624-.5c.817.432 2.03 1.638 3.756 1.442z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(AeroplaneHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
